export enum GrowthbookFlag {
  B2B = 'b2b',
  ExcludeThirdParty = 'exclude-third-party',
  Marketplace = 'marketplace',
  ConstructorRecommendations = 'constructor-recommendations',
  ShopTheLookMarkers = 'shop-the-look-markers',
  CrossDeviceAATestByCustomerId = 'cross-device-aa-test-by-customer-id',
  CrossDeviceAATestByExperienceV2 = 'cross-device-aa-test-by-ga-cid-or-experience-variant',
  CrossDeviceAATestByDeviceHash = 'cross-device-aa-test-by-device-hash',
  CrossDeviceAATestByExperienceVariant = 'cross-device-aa-test-by-experience-variant',
  CrossDeviceAATestByUnum = 'cross-device-aa-test-by-gtm-unum',
  CrossDeviceAATestByIp = 'cross-device-aa-test-by-ip',
  CrossDeviceAATestByRandom = 'cross-device-aa-test-by-random',
  CrossDeviceAATestPerBotType = 'cross-device-aa-test-per-bot-type',
  CrossDeviceAATestPDPView = 'cross-device-aa-test-pdp-view',
  CrossDeviceAATestPDPLazyLoadSliders = 'cross-device-aa-test-lazy-load-sliders',
  ReviewSummary = 'review-summary',
  SwipePLPGallery = 'swipe-plp-gallery',
  NativeAppDownloadMeta = 'native-app-download-meta',
  PDPMiniHeader = 'pdp-mini-header',
  PDPAutoScroll = 'pdp-auto-scroll',
  AbsoluteDiscount = 'absolute-discount',
  InlineQVDesignChanges = 'inlineqv-design-changes',
  InlineQVOnlyOnSales = 'inlineqv-only-on-sales',
  InlineQVGlobalRibbonBelow = 'inlineqv-global-ribbon-below',
  HideNavOnDesktop = 'hide-nav-on-desktop',
  HomeClubNudgeInRegistration = 'home-club-nudge-in-registration',
  PayPalPayLater = 'paypal-paylater',
  DynamicCMS = 'dynamic-cms',
  EnableVideoContent = 'enable-video-content',
  ClientSideNavigation = 'client-side-navigation',
  VerticalCategoryNavigation = 'vertical-category-navigation',
  ProductComparisonTable = 'product-comparison-table',
  AccessorySliderSmaller = 'accessory-slider-smaller',
  RecommendationsSliderSmaller = 'recommendations-slider-smaller',
  SideNavTabs = 'side-nav-tabs',
  ProductCardV2 = 'plp-redesign',
}
